var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronMedium = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "currentColor",
    d: "m.727 13.832.808.835 5.657-5.845.003.002L8 7.992l-.002-.003L8 7.987l-.808-.835-.002.002-5.633-5.82-.806.832 5.633 5.82z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.535 14.667-.359.348.36.37.359-.37zm-.808-.835-.359-.348-.337.348.337.348zm6.465-5.01.36-.348-.36-.371-.36.37zm.003.002-.36.348.36.371.36-.371zM8 7.992l.36.347.336-.347-.337-.348zm-.002-.003-.36-.347-.336.347.336.348zM8 7.987l.36.348.336-.348-.337-.348zm-.808-.835.359-.348-.36-.371-.359.371zm-.002.002-.36.348.36.371.359-.371-.36-.348Zm-5.633-5.82.359-.348-.36-.371-.359.371zm-.806.832-.36-.348-.336.348.337.348.36-.348Zm5.633 5.82.36.348.336-.347-.337-.348-.359.348Zm-4.49 6.333-.807-.835-.719.696.808.835.719-.696Zm4.939-5.845-5.657 5.845.719.696L7.55 9.169l-.718-.695Zm.721.003-.003-.003-.718.695.002.003zm.087-.833-.806.833.72.695.804-.833zm-.003.693.003.002.718-.695-.002-.002zm.003-.698-.003.003.719.695.002-.002zm-.808-.14.808.836.718-.696-.808-.835zm.716.003L7.55 7.5l-.719-.696-.002.003.719.695Zm-6.352-5.82 5.633 5.82.719-.695L1.916.986l-.719.695Zm-.086.832.805-.833-.719-.695-.805.832zm5.632 5.125-5.632-5.82-.72.695 5.634 5.82zm-5.656 6.54 5.656-5.845-.718-.695-5.657 5.845z",
    mask: "url(#chevron-medium_svg__a)"
  })));
};
export default SvgChevronMedium;